// Figure palette (TAV-3442) for Callout, FigureTile, Donut and SegmentedBar. Mirrors the $figure-* variables in
// src/styles/modules/_variables.scss: change both together. New constants only; existing palettes are untouched.
export const FIGURE_PALETTE = {
  blueDark: '#1E3A8A',
  blueMid: '#4F86E8',
  blueLight: '#C9DBF8',
  // Lighter amber (TAV-3482), closer to yellow so it reads apart from red: fills and outlines only. Text and icons use
  // `warning`, a darker shade that stays readable on white.
  amber: '#FDB022',
  danger: '#B42318',
  warning: '#A15C07',
  info: '#1E3A8A',
  neutral: '#111827',
} as const;
